var map = {
	"./game01-1.png": 97170,
	"./game01.png": 49292,
	"./game01_02.png": 18163,
	"./game02-1.png": 12257,
	"./game02.png": 17767,
	"./game02_02.png": 32778,
	"./game03-1.png": 5060,
	"./game03.png": 30078,
	"./game03_02.png": 87353,
	"./game04-1.png": 47435,
	"./game04.png": 66193,
	"./game04_02.png": 4152,
	"./game05-1.png": 84534,
	"./game05.png": 26248,
	"./game05_02.png": 94831,
	"./game06-1.png": 15141,
	"./game06.png": 63107,
	"./game06_02.png": 81862,
	"./game07-1.png": 48312,
	"./game07.png": 57882,
	"./game07_02.png": 4693
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39926;